/**
 * Kassirlar API — GET/POST/PUT/DELETE /api/cashiers.
 * Backend: snake_case, Frontend: camelCase.
 */
import api from './api';
import { endpoints } from './endpoints';

function normalizeCashier(raw) {
  if (!raw) return null;
  return {
    id: String(raw.id),
    name: raw.name ?? raw.full_name ?? '',
    phone: raw.phone ?? raw.cashier_phone ?? '',
    branchId: String(raw.branch_id ?? raw.branchId ?? ''),
    branchName: raw.branch_name ?? raw.branchName ?? '',
    status: raw.status ?? 'active',
    tenantId: raw.tenant_id != null ? String(raw.tenant_id) : raw.tenantId != null ? String(raw.tenantId) : '',
    cashierCanManageProducts: Boolean(raw.cashier_can_manage_products ?? raw.cashierCanManageProducts),
    cashierCanAddProductBarcodes: Boolean(raw.cashier_can_add_barcodes ?? raw.cashierCanAddBarcodes),
    cashierCanAddProductsOnly: Boolean(raw.cashier_can_add_products_only ?? raw.cashierCanAddProductsOnly),
    cashierPosOnly: Boolean(raw.cashier_pos_only ?? raw.cashierPosOnly),
  };
}

export async function getCashiers(params = {}) {
  const query = { ...params };
  if (query.pos_only === true) query.pos_only = 1;
  if (query.exclude_pos_only === true) query.exclude_pos_only = 1;
  const res = await api.get(endpoints.cashiers, { params: query });
  const raw = res?.data ?? res;
  const list = raw?.data ?? raw?.items ?? (Array.isArray(raw) ? raw : []);
  return (Array.isArray(list) ? list : []).map(normalizeCashier).filter(Boolean);
}

function trimLoginPassword(payload) {
  const raw = payload?.loginPassword ?? payload?.password;
  if (raw == null) return '';
  return String(raw).trim();
}

/** Kassir yaratish — branch_id majburiy (docs: BACKEND-MIJOZ-KASSIR-LOGIC.md) */
export async function createCashier(payload) {
  const branchId = payload.branchId ?? payload.branch_id;
  const pwd = trimLoginPassword(payload);
  const body = {
    name: payload.name?.trim() ?? '',
    phone: payload.phone?.trim() ?? '',
    branch_id: branchId ? Number(branchId) : undefined,
  };
  if (pwd) body.password = pwd;
  if (payload.cashierCanManageProducts !== undefined) {
    body.cashier_can_manage_products = !!payload.cashierCanManageProducts;
  }
  if (payload.cashierCanAddProductBarcodes !== undefined) {
    body.cashier_can_add_barcodes = !!payload.cashierCanAddProductBarcodes;
  }
  if (payload.cashierCanAddProductsOnly !== undefined) {
    body.cashier_can_add_products_only = !!payload.cashierCanAddProductsOnly;
  }
  if (payload.cashierPosOnly !== undefined) {
    body.cashier_pos_only = !!payload.cashierPosOnly;
  }
  const { data } = await api.post(endpoints.cashiers, body);
  return normalizeCashier(data?.data ?? data);
}

export async function updateCashier(id, payload) {
  const body = {};
  if (payload.name !== undefined) body.name = payload.name?.trim() ?? '';
  if (payload.phone !== undefined) body.phone = payload.phone?.trim() ?? '';
  if (payload.branchId !== undefined) body.branch_id = payload.branchId ? Number(payload.branchId) : null;
  if (payload.status !== undefined) body.status = payload.status;
  const pwd = trimLoginPassword(payload);
  if (pwd) body.password = pwd;
  if (payload.cashierCanManageProducts !== undefined) {
    body.cashier_can_manage_products = !!payload.cashierCanManageProducts;
  }
  if (payload.cashierCanAddProductBarcodes !== undefined) {
    body.cashier_can_add_barcodes = !!payload.cashierCanAddProductBarcodes;
  }
  if (payload.cashierCanAddProductsOnly !== undefined) {
    body.cashier_can_add_products_only = !!payload.cashierCanAddProductsOnly;
  }
  const { data } = await api.put(endpoints.cashierById(id), body);
  return normalizeCashier(data?.data ?? data);
}

export async function deleteCashier(id) {
  await api.delete(endpoints.cashierById(id));
}
